import { render } from "./header-logo.vue?vue&type=template&id=a4005750"
import script from "./header-logo.vue?vue&type=script&lang=js"
export * from "./header-logo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__